import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: false,
    field: 'companyName',
    title: 'Company Name',
    show: true,
    width: 312,
    valuesExport: [
      'companyName',
      'customerId',
      'status',
      'companySize',
      'country',
      'customerType'
    ]
  },
  {
    isSortable: true,
    field: 'createdDate',
    title: 'Create Date',
    show: true,
    width: 144,
    valuesExport: ['createdDate']
  },
  {
    isSortable: false,
    field: 'userCompanyEmail',
    title: 'User Company Email',
    show: true,
    width: 174,
    valuesExport: ['userCompanyEmail']
  },
  {
    isSortable: false,
    field: 'actionUserEmail',
    title: 'Action User Email',
    show: true,
    width: 174,
    valuesExport: ['actionUserEmail']
  },
  {
    isSortable: false,
    field: 'activity',
    title: 'Activity',
    show: true,
    width: 364,
    valuesExport: ['activity']
  },
  {
    isSortable: true,
    field: 'activityType',
    title: 'Activity Type',
    show: true,
    width: 152,
    valuesExport: ['activityType']
  },
  {
    isSortable: true,
    field: 'arrChanged',
    title: 'ARR',
    fromToGroup: true,
    show: true,
    width: 112,
    valuesExport: ['arrChanged']
  },
  {
    isSortable: true,
    field: 'arrStatus',
    title: 'Status',
    show: true,
    width: 120,
    valuesExport: ['status']
  },
  {
    isSortable: true,
    field: 'lastUpdate',
    title: 'Updated date',
    show: true,
    width: 122,
    valuesExport: ['lastUpdate']
  }
];

export const exportConfig = {
  exportUrl: '/mrr/activity/export',
  exportName: 'arr-activity',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  createdDate: { startDate: null, endDate: null },
  activityType: [],
  accountManager: [],
  customerSuccessEngineer: [],
  arrStatus: []
};

export const defaultNavigation = {
  fieldName: 'createdDate',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  arrChanged: {
    from: '',
    to: ''
  }
};
